import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Box, Autocomplete, TextField, CircularProgress } from "@mui/material";
import { getCountriesData } from "../apis/master";

const CountryRegionSelect = (props: any) => {
  const { country, setCountry, city, setCity, isEditing, adminCountry, urlCountryCode, urlRegionCode } = props;
  const { countryData, regions } = useSelector((state: any) => state.masterReducer);
  const [countryDetails, setCountryDetails] = useState(countryData);
  const [citiesData, setCities] = useState(regions);
  const [loading, setLoading] = useState(false);
  const [countryDropdownOpen, setCountryDropdown] = useState(false);
  const [cityDropdownOpen, setCityDropdown] = useState(false);

  const loadingCountries = countryDropdownOpen && countryDetails.length === 0;
  const loadingCities = cityDropdownOpen && citiesData.length === 0;

  const onCountryChange = (newValue: any) => {
    console.log("newValue", newValue);
    if (newValue) {
      setCountry(newValue);
      const citiData: any = countryDetails.filter(
        (item: any) => item.country_name === newValue?.country_name
      );
      setCities(citiData[0].regions);
    }
  };

  const onCityChange = (value: any) => {
    setCity(value);
  };

  const getData = async () => {
    setLoading(true);
    const data = await getCountriesData();
    // to set prepopulated values in case of edit
    filteredData(data);
    setCountryDetails(data);
    setLoading(false);
    if (!isEditing) {
      // If URL params are provided, use them instead of defaults
      // Check URL params first, even if country prop is null
      if (urlCountryCode) {
        const urlCountryObj = data.find((item: any) => item.country_code === urlCountryCode);
        if (urlCountryObj) {
          setCountry(urlCountryObj);
          setCities(urlCountryObj.regions);
          // Set city if URL param provided
          if (urlRegionCode && urlCountryObj.regions) {
            const urlRegionObj = urlCountryObj.regions.find((r: any) => r.region_code === urlRegionCode);
            if (urlRegionObj) {
              setCity(urlRegionObj);
            }
          }
          return; // Don't set defaults if we restored from URL
        }
      }
      
      // Only set defaults if country prop is null (not set by parent)
      if (!country) {
        if (adminCountry && adminCountry !== "all") {
          const citiData: any = data.filter((item: any) => item.country_code === adminCountry);
          console.log("citiData", citiData);
          if (citiData.length > 0) {
            setCountry(citiData[0]);
            setCities(citiData[0].regions);
          }
        } else {
          // Default to Ivory Coast
          const ivoryCoast = data.find((item: any) => item.country_code === "ivory-coast") || data[0];
          setCountry(ivoryCoast);
          setCities(ivoryCoast.regions);
        }
      }
    }
  };

  const filteredData = (data: any) => {
    console.log("filteredData", city, country, countryDetails, data);
    if (country || city) {
      const countryData: any = data.filter((item: any) => item.country_code === country);
      console.log("countryData[0]", countryData);
      setCountry(countryData?.[0]);
      const regionData: any = countryData[0]?.regions.filter(
        (item: any) => item.region_code === city
      );
      console.log("regionData", regionData);
      setCity(regionData?.[0]);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  // Update cities when country prop changes (from parent component)
  useEffect(() => {
    if (country && countryDetails.length > 0) {
      const citiData: any = countryDetails.filter(
        (item: any) => item.country_name === country?.country_name || item.country_code === country?.country_code
      );
      if (citiData.length > 0 && citiData[0].regions) {
        setCities(citiData[0].regions);
        
        // If URL has region_code and city is not set, restore city
        if (urlRegionCode && !city) {
          const urlRegionObj = citiData[0].regions.find((r: any) => r.region_code === urlRegionCode);
          if (urlRegionObj) {
            setCity(urlRegionObj);
          }
        }
      }
    }
  }, [country, countryDetails, urlRegionCode]);

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: "20px",
      }}
    >
      <Autocomplete
        disablePortal
        id="combo-box-demo"
        options={countryDetails}
        getOptionLabel={(option: any) => option?.country_name}
        sx={{ width: 420, marginRight: "20px" }}
        open={countryDropdownOpen}
        onOpen={() => {
          setCountryDropdown(true);
        }}
        onClose={() => {
          setCountryDropdown(false);
        }}
        loading={loading}
        loadingText="Loading countries.."
        value={country}
        onChange={(event: any, newValue: any) => {
          onCountryChange(newValue);
        }}
        disabled={isEditing || (adminCountry && adminCountry !== "all")}
        renderInput={(params: any) => (
          <TextField
            {...params}
            label="Country"
            size="small"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loadingCountries ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
      <Autocomplete
        disablePortal
        id="combo-box-demo"
        options={citiesData}
        value={city}
        onChange={(event: any, newValue: any) => {
          onCityChange(newValue);
        }}
        getOptionLabel={(option: any) => option.region_name}
        sx={{ width: 420 }}
        open={cityDropdownOpen}
        onOpen={() => {
          setCityDropdown(true);
        }}
        onClose={() => {
          setCityDropdown(false);
        }}
        disabled={isEditing}
        renderInput={(params: any) => (
          <TextField
            {...params}
            label="Region"
            size="small"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loadingCities ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </Box>
  );
};
export default CountryRegionSelect;
